(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-newsletter-advanced"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewsletterAdv(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var form = root.querySelector('[data-newsletter-form-wrapper] form');
    if (!form) return;

    var field = root.querySelector('[data-newsletter-field]');
    var input = root.querySelector('[data-newsletter-input]');
    var submitBtn = root.querySelector('[data-newsletter-submit]');
    var inlineError = root.querySelector('[data-newsletter-inline-error]');
    var consent = root.querySelector('[data-newsletter-consent]');
    var wrapper = root.querySelector('[data-newsletter-form-wrapper]');

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showInlineError(msg) {
      if (!inlineError) return;
      inlineError.textContent = msg;
      inlineError.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    function bindCopyButtons(scope) {
      var btn = scope.querySelector('[data-newsletter-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.dataset.copied = 'true';
          var original = btn.textContent;
          btn.textContent = 'Copié !';
          setTimeout(function () {
            btn.textContent = original;
            btn.dataset.copied = 'false';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
        } else {
          fallbackCopy(code, done);
        }
      });
    }
    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
    bindCopyButtons(root);

    form.addEventListener('submit', function (e) {
      clearInlineError();

      var emailValue = input ? input.value.trim() : '';
      if (!emailValue || !emailRe.test(emailValue)) {
        e.preventDefault();
        showInlineError('Veuillez saisir une adresse e-mail valide.');
        if (input) input.focus();
        return;
      }
      if (consent && !consent.checked) {
        e.preventDefault();
        showInlineError('Veuillez accepter pour continuer.');
        return;
      }

      // Progressive enhancement: try a no-reload submit. If anything goes
      // wrong, fall back to a normal form post (full page reload).
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      e.preventDefault();
      setLoading(true);

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.getElementById(root.id);
          if (!freshRoot) {
            form.submit();
            return;
          }
          var freshWrapper = freshRoot.querySelector('[data-newsletter-form-wrapper]');
          if (freshWrapper && wrapper) {
            wrapper.innerHTML = freshWrapper.innerHTML;
            var successEl = wrapper.querySelector('[data-newsletter-success]');
            var errorEl = wrapper.querySelector('[data-newsletter-error]');
            var focusTarget = successEl || errorEl;
            if (focusTarget) focusTarget.focus({ preventScroll: false });
            bindCopyButtons(wrapper);
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-newsletter-section]').forEach(initNewsletterAdv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-reviews-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function store(key, value) {
      try {
        if (value === undefined) return localStorage.getItem(key);
        if (value === null) localStorage.removeItem(key);
        else localStorage.setItem(key, value);
      } catch (e) {
        return null;
      }
    }

    // Rolling dates: recompute "today - N days" in the visitor's browser, so the dates stay
    // current even when the page is served from cache.
    function formatDate(root, days) {
      var d = root.dataset;
      if (d.dateFormat === 'relative') {
        if (days === 0) return d.tToday;
        if (days === 1) return d.tYesterday;
        if (days < 7) return d.tDays.replace('[n]', days);
        if (days < 14) return d.tWeek;
        if (days < 30) return d.tWeeks.replace('[n]', Math.floor(days / 7));
        if (days < 60) return d.tMonth;
        return d.tMonths.replace('[n]', Math.floor(days / 30));
      }
      var date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() - days);
      var opts = d.dateFormat === 'short'
        ? { day: '2-digit', month: '2-digit', year: 'numeric' }
        : { day: 'numeric', month: 'long', year: 'numeric' };
      try {
        return new Intl.DateTimeFormat(d.locale || 'fr-FR', opts).format(date);
      } catch (e) {
        return null;
      }
    }

    function refreshDates(root) {
      if (root.dataset.dateSource !== 'rolling') return;
      root.querySelectorAll('[data-aa-rv-days]').forEach(function (el) {
        var days = parseInt(el.dataset.aaRvDays, 10);
        if (isNaN(days)) return;
        var text = formatDate(root, days);
        if (text) el.textContent = text;
      });
    }

    function initReviews(root) {
      if (!root || root.dataset.aaRvInit === 'true') return;
      root.dataset.aaRvInit = 'true';

      refreshDates(root);

      var list = root.querySelector('[data-aa-rv-list]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-aa-rv-item]'));
      var moreBtn = root.querySelector('[data-aa-rv-more]');
      var sortSelect = root.querySelector('[data-aa-rv-sort]');
      var perPage = parseInt(root.dataset.perPage, 10) || 5;
      var shown = perPage;

      function paginate() {
        var ordered = list.querySelectorAll('[data-aa-rv-item]');
        ordered.forEach(function (item, i) {
          item.hidden = i >= shown;
        });
        if (moreBtn) moreBtn.hidden = shown >= ordered.length;
      }

      function num(item, key) {
        return parseFloat(item.dataset[key]) || 0;
      }

      function sortBy(mode) {
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'highest') return num(b, 'rating') - num(a, 'rating') || num(a, 'days') - num(b, 'days');
          if (mode === 'lowest') return num(a, 'rating') - num(b, 'rating') || num(a, 'days') - num(b, 'days');
          if (mode === 'helpful') return num(b, 'helpful') - num(a, 'helpful') || num(a, 'days') - num(b, 'days');
          if (mode === 'media') {
            var am = a.dataset.media === 'true' ? 0 : 1;
            var bm = b.dataset.media === 'true' ? 0 : 1;
            return am - bm || num(a, 'days') - num(b, 'days');
          }
          return num(a, 'days') - num(b, 'days') || num(a, 'index') - num(b, 'index');
        });
        sorted.forEach(function (item) {
          list.appendChild(item);
        });
        shown = perPage;
        paginate();
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortBy(sortSelect.value);
        });
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          var firstHidden = list.querySelector('[data-aa-rv-item][hidden]');
          shown += perPage;
          paginate();
          if (firstHidden) firstHidden.setAttribute('tabindex', '-1'), firstHidden.focus({ preventScroll: true });
        });
      }

      // Start in "most recent" order, whatever order the blocks are in.
      sortBy('recent');

      // Helpful votes: one vote per review per browser, can be changed or undone.
      root.querySelectorAll('[data-aa-rv-helpful]').forEach(function (group) {
        var key = 'aa-rv-vote-' + group.dataset.key;
        var buttons = group.querySelectorAll('[data-vote]');

        function render(vote) {
          buttons.forEach(function (btn) {
            var active = btn.dataset.vote === vote;
            var base = parseInt(btn.dataset.base, 10) || 0;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            btn.querySelector('[data-count]').textContent = base + (active ? 1 : 0);
          });
        }

        render(store(key));

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var current = store(key);
            var next = current === btn.dataset.vote ? null : btn.dataset.vote;
            store(key, next);
            render(next);
          });
        });
      });

      // Photo popup.
      var dialog = root.querySelector('[data-aa-rv-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        var dialogImg = dialog.querySelector('[data-aa-rv-dialog-img]');
        root.querySelectorAll('[data-aa-rv-photo]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var thumb = btn.querySelector('img');
            dialogImg.src = btn.dataset.aaRvPhoto;
            dialogImg.alt = thumb ? thumb.alt : '';
            dialog.showModal();
          });
        });
        dialog.querySelector('[data-aa-rv-close]').addEventListener('click', function () {
          dialog.close();
        });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', function () {
          dialogImg.removeAttribute('src');
        });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-aa-rv]').forEach(initReviews);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-winter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-winter-hero"] && !Shopify.designMode) return;
  try {
    
function aaWinterHeroInitCountdowns() {
  document.querySelectorAll('[data-aa-wh-countdown]').forEach(function (el) {
    if (el.dataset.aaInit) return;
    el.dataset.aaInit = 'true';

    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var wrap = el.closest('[data-aa-wh-countdown-wrap]');
    var expiredEl = wrap ? wrap.querySelector('[data-expired-message]') : null;
    var sectionEl = el.closest('.aa-winter-hero');
    var hideSection = el.dataset.hideOnExpire === 'true';
    var timer;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (hideSection && sectionEl) sectionEl.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400000));
      if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (secondsEl) secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  });
}

function aaWinterHeroInitCopyButtons() {
  document.querySelectorAll('.aa-winter-hero__code-copy').forEach(function (btn) {
    if (btn.dataset.aaInit) return;
    btn.dataset.aaInit = 'true';

    btn.addEventListener('click', function () {
      var text = btn.dataset.copy;
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        var original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied!';
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      });
    });
  });
}

// Desktop keeps the highlight on one line; if a long translation doesn't fit the content
// width, scale its text down until it does (mobile wraps instead, so it's left alone).
function aaWinterHeroFitHighlights() {
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-aa-wh-highlight]').forEach(function (el) {
    el.style.fontSize = '';
    if (!desktop) return;
    var available = el.parentElement.clientWidth - 8;
    var needed = el.scrollWidth;
    if (needed > available && available > 0) {
      var size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * available / needed) + 'px';
    }
  });
}

var aaWinterHeroResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(aaWinterHeroResizeTimer);
  aaWinterHeroResizeTimer = setTimeout(aaWinterHeroFitHighlights, 150);
});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(aaWinterHeroFitHighlights);

aaWinterHeroInitCountdowns();
aaWinterHeroInitCopyButtons();
aaWinterHeroFitHighlights();
document.addEventListener('shopify:section:load', function () {
  aaWinterHeroInitCountdowns();
  aaWinterHeroInitCopyButtons();
  aaWinterHeroFitHighlights();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
